import { createSlice } from "@reduxjs/toolkit";

interface DonationsState{
    loading: boolean;
    error: string | null;
    donations: Array<{
        id: string;
        amount: number;
        currency: string;
        recipient: string;
        date: string;
    }>;
}

const initialState: DonationsState = {
    loading: false,
    error: null,
    donations: [],
};

const donationsSlice = createSlice({
    name: "donations",
    initialState,
    reducers: {
        fetchDonationsStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        fetchDonationsSuccess: (state, action) => {
            state.loading = false;
            state.donations = action.payload;
        },
        fetchDonationsFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        addDonation: (state, action) => {
            state.donations.push(action.payload);
        },
        removeDonation: (state, action) => {
            state.donations = state.donations.filter(donation => donation.id !== action.payload);
        },
    },
});

export const {
    fetchDonationsStart,
    fetchDonationsSuccess,
    fetchDonationsFailure,
    addDonation,
    removeDonation,
} = donationsSlice.actions;
export default donationsSlice.reducer;